
<app-glow>
  <div class="todo">
    <app-header *ngIf="showNav"></app-header>
    <div id="content" class="content">
      <main class="content_main" [@routeAnimations]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet" (activate)="onRouteActivate()"></router-outlet>
      </main>
    </div>
    <app-footer></app-footer>
  </div>
</app-glow>

